module.exports = __webpack_public_path__ + "static/media/shaff1148.72e58e1c.jpg";